import { environment } from 'src/environments/environment';
import { TrustedLogoService } from '../services/trustedlogo.service';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';

@Component({
  selector: 'app-trusted-logo',
  templateUrl: './trusted-logo.component.html',
  styleUrls: ['./trusted-logo.component.css']
})
export class TrustedLogoComponent implements OnInit {

  id: number
  photo: any
  isEdit: boolean = false
  fileInvalid = false;
  selectedFile: File
  logoList: any[]
  baseUrl: string = environment.url;
  @ViewChild('image') image: ElementRef

  constructor(
    private trustedLogoSerivce: TrustedLogoService) { }

  ngOnInit(): void {
    this.getAll();
  }

  addStats() {

    if (!this.fileInvalid && this.selectedFile) {
      const formData = new FormData();
      formData.append('image', this.selectedFile);

      if (this.isEdit) {
        this.trustedLogoSerivce.edit(this.id, formData).subscribe(response => {
          this.clear()
        })
      } else {
        this.trustedLogoSerivce.add(formData).subscribe((response: any) => {
          this.logoList.unshift({ image:response.addTrustedLogo.image});
          this.clear();
        })
      }
    } else {
      this.fileInvalid = true;
    }
  }

  clear() {
    this.selectedFile = null;
    this.image.nativeElement.value = ''
    this.isEdit = false
    this.photo = null
    this.getAll()
  }

  onFileChange(event) {
    const file = event.target.files[0];
    if (file && file.type.startsWith('image/')) {
      this.fileInvalid = false;
      this.selectedFile = file;

      const reader = new FileReader();
      reader.onload = (e: any) => {
        const img = new Image();
        img.onload = () => {
          const width = img.width;
          const height = img.height;
          
          if(height < 120 || width < 120) {
            this.fileInvalid = true    
          } else {
            this.photo = reader.result;
          }
        };
        img.src = e.target.result;
      };
      reader.readAsDataURL(file);
      this.fileInvalid=false
    } else {
      this.fileInvalid = true;
      this.selectedFile = null;
    }
  }

  getAll() {
    this.trustedLogoSerivce.getAll().subscribe((response: any) => {
      this.logoList = response.getTrusted
    })
  }

  edit(id: number, file) {
    this.id = id
    this.isEdit = true
    this.photo =  file
  }

  delete(id) {
    const index = this.logoList.findIndex(item => item._id === id);
    this.trustedLogoSerivce.delete(id).subscribe(response => {
      this.logoList.splice(index, 1);
    })
  }


}
